module.exports = __webpack_public_path__ + "img/gzh.56461acb.jpg";